<template>
  <footer id="footer">
    <div id="pagetop">
      <a href="#" class="scroll"
        ><img src="@/assets/img/common/pagetop.png" alt="ページトップ"
      /></a>
    </div>
    <div class="inner">
      <div class="footer_area">
        <div class="footer_logo">
          <router-link :to="{ name: 'home' }" @click.native="scrollToTop">
            <img src="@/assets/img/common/f_logo.png" alt="天下一品ロゴ" />
          </router-link>
        </div>
        <div class="footer_menu">
          <ul class="footer_list">
            <li
              v-for="item in list"
              :key="item.name"
              @click="getCreateUrl(item.route)"
            >
              <a>
                <span class="arrow_r_r01">{{ item.name }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="footer_banner">
          <a target="_blank" rel="noopener" v-bind:href="getCorporatePageUrl()">
            <img
              src="@/assets/img/common/corporate_banner.png"
              alt="天下一品ロゴ"
            />
          </a>
        </div>
      </div>
    </div>
    <div id="copyright" class="bg_red01">
      <div class="inner">
        <p>
          Copyright © {{ year }} TENICHI SHOKUHIN SHOJI, K.K. All rights
          reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "RwvFooter",
  data() {
    return {
      list: [
        {
          route: `company`,
          name: "運営会社"
        },
        {
          route: "/store/faq",
          name: "よくあるご質問"
        },
        {
          route: `privacy`,
          name: "個人情報保護方針"
        },
        {
          route: "/store/guide",
          name: "お買い物ガイド"
        },
        {
          route: "/store/tokushoho",
          name: "特定商取引法に基づく表記"
        },
        {
          route: `contact`,
          name: "お問い合わせ"
        }
      ]
    };
  },
  computed: {
    year() {
      let y = new Date();
      return y.getFullYear();
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getCreateUrl(url) {
      if (url === "company") {
        location.href = `${process.env.VUE_APP_COMPANY_URL}`;
      } else if (url === "privacy") {
        location.href = `${process.env.VUE_APP_PRIVACY_URL}`;
      } else if (url === "contact") {
        location.href = `${process.env.VUE_APP_CONTACT_URL}`;
      } else {
        location.href = `${url}`;
      }
    },
    getCorporatePageUrl() {
      return process.env.VUE_APP_CORPORATE_URL;
    }
  }
};
</script>
